import { Api } from './client'
import { genericApi } from '../../config/api'

export const GenericApiClient = new Api(genericApi)
